export const getImageSourceFromBase64 = (
  mimetype?: string | null,
  base64?: string | null,
): string | undefined => {
  if (!base64 || !mimetype) {
    return undefined;
  }

  return `data:${mimetype};base64,${base64}`;
};

export const uint8ToDataUrl = (bytes: Uint8Array, mimeType: string) => {
  let binary = "";

  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }

  const base64 = btoa(binary);
  return `data:${mimeType};base64,${base64}`;
};
